/* LoadingSpinner.tsx generated by @compiled/babel-plugin v0.26.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Box, Stack, xcss } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
import React from 'react';
const spinnerWrapperStyles = xcss({
  height: 'size.1000'
});
const loadingTextStyles = xcss({
  fontSize: '1rem',
  color: 'color.text.subtle'
});
export const LoadingSpinner = () => /*#__PURE__*/React.createElement(Stack, {
  alignBlock: "center",
  alignInline: "center",
  space: "space.200",
  xcss: spinnerWrapperStyles
}, /*#__PURE__*/React.createElement(Spinner, {
  size: "large"
}), /*#__PURE__*/React.createElement(Box, {
  xcss: loadingTextStyles
}, "Loading..."));